export const TRANSLATION_LANGUAGES = ['fi', 'en', 'zh', 'es', 'fr', 'ptbr'];

export const TRANSLATION_LANGUAGE_OPTIONS = [
  { value: 'fi', label: 'Suomi' },
  { value: 'en', label: 'English' },
  { value: 'zh', label: '中文' },
  { value: 'es', label: 'Español' },
  { value: 'fr', label: 'Français' },
  { value: 'ptbr', label: 'Português(BR)' },
];
